import _axios from 'axios';

import { ENV_VARS } from '@/env';

import { API } from '../../api';
import {
  addCompanyIdInterceptor,
  ExpireTokenInterceptor,
  obsoleteEndpointInterceptor,
  setTokenInterceptor,
} from '../../redux/interceptors';
import { getLocalTimeZone } from '../../utils/date';
import { deprecate } from '../deprecate';

_axios.create = deprecate(_axios.create, {
  message: `axios is deprecated. Use fetcher from @/services/fetcher
    By the way we have to use only one instance of axios via the whole project`,
});

export const axiosInstance = _axios.create({
  baseURL: API.BASE,
  headers: {
    'X-Client-Version': ENV_VARS.VERSION,
    'X-Time-Zone': getLocalTimeZone(),
  },
});

axiosInstance.CancelToken = _axios.CancelToken;

axiosInstance.interceptors.request.use(setTokenInterceptor, (error) => Promise.reject(error));
axiosInstance.interceptors.request.use(addCompanyIdInterceptor, (error) => Promise.reject(error));

axiosInstance.interceptors.response.use(obsoleteEndpointInterceptor, ExpireTokenInterceptor);
